import React, { createContext, useContext, useEffect, useState } from "react";

export const DICT = {
  de: {
    "nav.home": "Startseite", "nav.services": "Leistungen", "nav.web": "Web-Entwicklung",
    "nav.mobile": "App-Entwicklung", "nav.software": "Unternehmenssoftware",
    "nav.packages": "Pakete & Preise", "nav.portfolio": "Portfolio", "nav.process": "Ablauf",
    "nav.about": "Über uns", "nav.faq": "FAQ", "nav.blog": "Blog", "nav.contact": "Kontakt",
    "nav.login": "Anmelden", "nav.register": "Registrieren", "nav.quote": "Angebot anfordern",
    "nav.portal": "Kundenportal", "nav.admin": "Admin", "nav.logout": "Abmelden", "nav.more": "Mehr", "nav.shop": "Shop",
    "common.learnMore": "Mehr erfahren", "common.getStarted": "Jetzt starten",
    "common.viewAll": "Alle anzeigen", "common.from": "ab", "common.send": "Senden",
    "common.save": "Speichern", "common.cancel": "Abbrechen", "common.delete": "Löschen",
    "common.edit": "Bearbeiten", "common.create": "Erstellen", "common.back": "Zurück",
    "common.loading": "Laden…", "common.search": "Suchen", "common.status": "Status",
    "common.total": "Gesamt", "common.actions": "Aktionen", "common.name": "Name",
    "common.email": "E-Mail", "common.date": "Datum", "common.close": "Schließen",
    "common.duplicate": "Duplizieren", "common.none": "Keine Einträge",
    "hero.badge": "Premium Software-Agentur",
    "hero.cta1": "Angebot anfordern", "hero.cta2": "Portfolio ansehen",
    "hero.desc": "Wir entwerfen und entwickeln professionelle Websites, mobile Apps und maßgeschneiderte Unternehmenssoftware für Android, iOS und das Web.",
    "home.servicesTitle": "Unsere Leistungen", "home.servicesSub": "Alles, was Ihr Unternehmen digital braucht — aus einer Hand.",
    "home.techTitle": "Unsere Technologien", "home.techSub": "Wir wählen die passende Technologie für jedes Projekt.",
    "home.processTitle": "So arbeiten wir", "home.processSub": "Ein klarer, transparenter Ablauf von der Idee bis zum Launch.",
    "home.portfolioTitle": "Ausgewählte Projekte", "home.portfolioSub": "Ein Einblick in unsere Arbeit.",
    "home.packagesTitle": "Pakete & Preise", "home.packagesSub": "Transparente Preise für jeden Bedarf.",
    "home.testimonialsTitle": "Was Kunden sagen", "home.statsTitle": "In Zahlen",
    "home.faqTitle": "Häufige Fragen", "home.ctaTitle": "Bereit für Ihr digitales Projekt?",
    "home.ctaDesc": "Lassen Sie uns gemeinsam etwas Großartiges bauen. Fordern Sie noch heute ein unverbindliches Angebot an.",
    "stats.projects": "Projekte", "stats.clients": "Kunden", "stats.years": "Jahre Erfahrung", "stats.satisfaction": "Zufriedenheit",
    "auth.loginTitle": "Willkommen zurück", "auth.registerTitle": "Konto erstellen",
    "auth.backHome": "Zurück zur Startseite",
    "auth.password": "Passwort", "auth.firstName": "Vorname", "auth.lastName": "Nachname",
    "auth.company": "Firma", "auth.phone": "Telefon", "auth.forgot": "Passwort vergessen?",
    "auth.noAccount": "Noch kein Konto?", "auth.hasAccount": "Bereits registriert?",
    "auth.google": "Mit Google anmelden", "auth.or": "oder",
    "auth.googleContinue": "Mit Google fortfahren",
    "auth.googleErr.cancelled": "Google-Anmeldung abgebrochen.",
    "auth.googleErr.failed": "Google-Anmeldung fehlgeschlagen. Bitte erneut versuchen.",
    "auth.googleErr.disabled": "Google-Anmeldung ist derzeit nicht verfügbar.",
    "auth.googleErr.unverified": "Ihre Google-E-Mail ist nicht verifiziert.",
    "auth.googleSuccess": "Erfolgreich mit Google angemeldet!",
    "quote.title": "Angebot anfordern", "quote.desc": "Erzählen Sie uns von Ihrem Projekt — wir melden uns mit einem individuellen Angebot.",
    "quote.projectType": "Projektart", "quote.platform": "Plattform", "quote.budget": "Budget",
    "quote.deadline": "Wunschtermin", "quote.description": "Projektbeschreibung", "quote.features": "Gewünschte Funktionen",
    "quote.gdpr": "Ich stimme der Datenschutzerklärung zu.", "quote.submit": "Anfrage senden",
    "quote.success": "Vielen Dank! Ihre Anfrage wurde gesendet.",
    "contact.title": "Kontakt", "contact.subject": "Betreff", "contact.message": "Nachricht",
    "contact.success": "Nachricht gesendet. Wir melden uns bald!",
    "portal.dashboard": "Übersicht", "portal.offers": "Angebote", "portal.orders": "Bestellungen",
    "portal.projects": "Projekte", "portal.invoices": "Rechnungen", "portal.files": "Dateien",
    "portal.messages": "Nachrichten", "portal.tickets": "Support", "portal.profile": "Profil", "portal.purchases": "Meine Käufe",
    "portal.welcome": "Willkommen", "portal.activeProjects": "Aktive Projekte",
    "portal.openOffers": "Offene Angebote", "portal.unpaidInvoices": "Offene Rechnungen",
    "portal.openTickets": "Offene Tickets", "portal.pay": "Jetzt bezahlen", "portal.download": "PDF herunterladen",
    "portal.accept": "Annehmen", "portal.reject": "Ablehnen", "portal.newTicket": "Neues Ticket",
    "portal.newMessage": "Neue Nachricht", "portal.reply": "Antworten", "portal.progress": "Fortschritt",
    "admin.dashboard": "Dashboard", "admin.revenue": "Umsatz", "admin.customers": "Kunden",
    "admin.newQuotes": "Neue Anfragen", "admin.services": "Leistungen", "admin.packages": "Pakete",
    "admin.portfolio": "Portfolio", "admin.blog": "Blog", "admin.testimonials": "Referenzen",
    "admin.faqs": "FAQ", "admin.quotes": "Anfragen", "admin.offers": "Angebote", "admin.orders": "Bestellungen", "admin.shop": "Shop",
    "admin.projects": "Projekte", "admin.invoices": "Rechnungen", "admin.tickets": "Support",
    "admin.messages": "Nachrichten", "admin.users": "Benutzer", "admin.leads": "Leads",
    "admin.payments": "Zahlungen", "admin.settings": "Einstellungen", "admin.cms": "Website-CMS",
    "admin.paymentMethods": "Zahlungsarten & Zahlungsanbieter",
    "admin.emailConfig": "E-Mail-Konfiguration", "admin.emailTemplates": "E-Mail-Vorlagen",
    "footer.tagline": "Websites. Mobile Apps. Unternehmenssoftware.",
    "footer.company": "Unternehmen", "footer.legal": "Rechtliches", "footer.rights": "Alle Rechte vorbehalten.",
    "legal.imprint": "Impressum", "legal.privacy": "Datenschutz", "legal.terms": "AGB", "legal.withdrawal": "Widerrufsbelehrung",
    "cookie.text": "Wir verwenden Cookies, um Ihr Erlebnis zu verbessern.",
    "cookie.accept": "Alle akzeptieren", "cookie.necessary": "Nur notwendige",
  },
  en: {
    "nav.home": "Home", "nav.services": "Services", "nav.web": "Web Development",
    "nav.mobile": "App Development", "nav.software": "Business Software",
    "nav.packages": "Packages & Pricing", "nav.portfolio": "Portfolio", "nav.process": "How It Works",
    "nav.about": "About Us", "nav.faq": "FAQ", "nav.blog": "Blog", "nav.contact": "Contact",
    "nav.login": "Login", "nav.register": "Register", "nav.quote": "Get a Quote",
    "nav.portal": "Customer Portal", "nav.admin": "Admin", "nav.logout": "Logout", "nav.more": "More", "nav.shop": "Shop",
    "common.learnMore": "Learn more", "common.getStarted": "Get started",
    "common.viewAll": "View all", "common.from": "from", "common.send": "Send",
    "common.save": "Save", "common.cancel": "Cancel", "common.delete": "Delete",
    "common.edit": "Edit", "common.create": "Create", "common.back": "Back",
    "common.loading": "Loading…", "common.search": "Search", "common.status": "Status",
    "common.total": "Total", "common.actions": "Actions", "common.name": "Name",
    "common.email": "Email", "common.date": "Date", "common.close": "Close",
    "common.duplicate": "Duplicate", "common.none": "No entries",
    "hero.badge": "Premium Software Agency",
    "hero.cta1": "Get a Quote", "hero.cta2": "View Portfolio",
    "hero.desc": "We design and develop professional websites, mobile apps and custom business software for Android, iOS and the web.",
    "home.servicesTitle": "Our Services", "home.servicesSub": "Everything your business needs digitally — from a single source.",
    "home.techTitle": "Our Technologies", "home.techSub": "We choose the right technology for each project.",
    "home.processTitle": "How We Work", "home.processSub": "A clear, transparent process from idea to launch.",
    "home.portfolioTitle": "Selected Projects", "home.portfolioSub": "A glimpse into our work.",
    "home.packagesTitle": "Packages & Pricing", "home.packagesSub": "Transparent pricing for every need.",
    "home.testimonialsTitle": "What Clients Say", "home.statsTitle": "By the Numbers",
    "home.faqTitle": "Frequently Asked Questions", "home.ctaTitle": "Ready for your digital project?",
    "home.ctaDesc": "Let's build something great together. Request a free quote today.",
    "stats.projects": "Projects", "stats.clients": "Clients", "stats.years": "Years experience", "stats.satisfaction": "Satisfaction",
    "auth.loginTitle": "Welcome back", "auth.registerTitle": "Create account",
    "auth.backHome": "Back to homepage",
    "auth.password": "Password", "auth.firstName": "First name", "auth.lastName": "Last name",
    "auth.company": "Company", "auth.phone": "Phone", "auth.forgot": "Forgot password?",
    "auth.noAccount": "No account yet?", "auth.hasAccount": "Already registered?",
    "auth.google": "Sign in with Google", "auth.or": "or",
    "auth.googleContinue": "Continue with Google",
    "auth.googleErr.cancelled": "Google sign-in was cancelled.",
    "auth.googleErr.failed": "Google sign-in failed. Please try again.",
    "auth.googleErr.disabled": "Google sign-in is currently unavailable.",
    "auth.googleErr.unverified": "Your Google email is not verified.",
    "auth.googleSuccess": "Signed in with Google!",
    "quote.title": "Get a Quote", "quote.desc": "Tell us about your project — we'll get back with a custom offer.",
    "quote.projectType": "Project type", "quote.platform": "Platform", "quote.budget": "Budget",
    "quote.deadline": "Desired deadline", "quote.description": "Project description", "quote.features": "Required features",
    "quote.gdpr": "I agree to the privacy policy.", "quote.submit": "Send request",
    "quote.success": "Thank you! Your request has been sent.",
    "contact.title": "Contact", "contact.subject": "Subject", "contact.message": "Message",
    "contact.success": "Message sent. We'll be in touch soon!",
    "portal.dashboard": "Overview", "portal.offers": "Offers", "portal.orders": "Orders",
    "portal.projects": "Projects", "portal.invoices": "Invoices", "portal.files": "Files",
    "portal.messages": "Messages", "portal.tickets": "Support", "portal.profile": "Profile", "portal.purchases": "My Purchases",
    "portal.welcome": "Welcome", "portal.activeProjects": "Active projects",
    "portal.openOffers": "Open offers", "portal.unpaidInvoices": "Unpaid invoices",
    "portal.openTickets": "Open tickets", "portal.pay": "Pay now", "portal.download": "Download PDF",
    "portal.accept": "Accept", "portal.reject": "Reject", "portal.newTicket": "New ticket",
    "portal.newMessage": "New message", "portal.reply": "Reply", "portal.progress": "Progress",
    "admin.dashboard": "Dashboard", "admin.revenue": "Revenue", "admin.customers": "Customers",
    "admin.newQuotes": "New quotes", "admin.services": "Services", "admin.packages": "Packages",
    "admin.portfolio": "Portfolio", "admin.blog": "Blog", "admin.testimonials": "Testimonials",
    "admin.faqs": "FAQ", "admin.quotes": "Quotes", "admin.offers": "Offers", "admin.orders": "Orders", "admin.shop": "Shop",
    "admin.projects": "Projects", "admin.invoices": "Invoices", "admin.tickets": "Support",
    "admin.messages": "Messages", "admin.users": "Users", "admin.leads": "Leads",
    "admin.payments": "Payments", "admin.settings": "Settings", "admin.cms": "Website CMS",
    "admin.paymentMethods": "Payment Methods & Providers",
    "admin.emailConfig": "Email Configuration", "admin.emailTemplates": "Email Templates",
    "footer.tagline": "Websites. Mobile Apps. Business Software.",
    "footer.company": "Company", "footer.legal": "Legal", "footer.rights": "All rights reserved.",
    "legal.imprint": "Imprint", "legal.privacy": "Privacy Policy", "legal.terms": "Terms", "legal.withdrawal": "Cancellation Policy",
    "cookie.text": "We use cookies to improve your experience.",
    "cookie.accept": "Accept all", "cookie.necessary": "Necessary only",
  },
};

// Unified DE/EN labels for all status & priority enums used across the app.
export const STATUS_LABELS = {
  paid: { de: "Bezahlt", en: "Paid" },
  unpaid: { de: "Offen", en: "Unpaid" },
  open: { de: "Offen", en: "Open" },
  overdue: { de: "Überfällig", en: "Overdue" },
  pending: { de: "Ausstehend", en: "Pending" },
  awaiting_payment: { de: "Zahlung ausstehend", en: "Awaiting payment" },
  cancelled: { de: "Storniert", en: "Cancelled" },
  canceled: { de: "Storniert", en: "Canceled" },
  refunded: { de: "Erstattet", en: "Refunded" },
  partially_refunded: { de: "Teilweise erstattet", en: "Partially refunded" },
  partially_paid: { de: "Teilweise bezahlt", en: "Partially paid" },
  expired: { de: "Abgelaufen", en: "Expired" },
  processing: { de: "In Bearbeitung", en: "Processing" },
  authorized: { de: "Autorisiert", en: "Authorized" },
  failed: { de: "Fehlgeschlagen", en: "Failed" },
  created: { de: "Erstellt", en: "Created" },
  requires_action: { de: "Aktion erforderlich", en: "Requires action" },
  disputed: { de: "Angefochten", en: "Disputed" },
  returned: { de: "Zurückgebucht", en: "Returned" },
  complete: { de: "Abgeschlossen", en: "Complete" },
  completed: { de: "Abgeschlossen", en: "Completed" },
  no_payment_required: { de: "Keine Zahlung nötig", en: "No payment required" },
  draft: { de: "Entwurf", en: "Draft" },
  sent: { de: "Gesendet", en: "Sent" },
  accepted: { de: "Angenommen", en: "Accepted" },
  rejected: { de: "Abgelehnt", en: "Rejected" },
  converted: { de: "Umgewandelt", en: "Converted" },
  new: { de: "Neu", en: "New" },
  reviewing: { de: "In Prüfung", en: "Reviewing" },
  info_required: { de: "Infos benötigt", en: "Info required" },
  offer_prepared: { de: "Angebot vorbereitet", en: "Offer prepared" },
  offer_sent: { de: "Angebot gesendet", en: "Offer sent" },
  contacted: { de: "Kontaktiert", en: "Contacted" },
  qualified: { de: "Qualifiziert", en: "Qualified" },
  in_review: { de: "In Prüfung", en: "In review" },
  lost: { de: "Verloren", en: "Lost" },
  won: { de: "Gewonnen", en: "Won" },
  planning: { de: "Planung", en: "Planning" },
  waiting_customer: { de: "Wartet auf Kunde", en: "Waiting on customer" },
  design: { de: "Design", en: "Design" },
  development: { de: "Entwicklung", en: "Development" },
  testing: { de: "Test", en: "Testing" },
  customer_review: { de: "Kundenprüfung", en: "Customer review" },
  revision: { de: "Überarbeitung", en: "Revision" },
  ready_launch: { de: "Startbereit", en: "Ready to launch" },
  on_hold: { de: "Pausiert", en: "On hold" },
  in_progress: { de: "In Bearbeitung", en: "In progress" },
  resolved: { de: "Gelöst", en: "Resolved" },
  closed: { de: "Geschlossen", en: "Closed" },
  low: { de: "Niedrig", en: "Low" },
  normal: { de: "Normal", en: "Normal" },
  medium: { de: "Mittel", en: "Medium" },
  high: { de: "Hoch", en: "High" },
  urgent: { de: "Dringend", en: "Urgent" },
};

export function statusLabel(s, lang = "de") {
  if (s === null || s === undefined || s === "") return "—";
  const key = String(s).toLowerCase();
  const entry = STATUS_LABELS[key];
  if (entry) return entry[lang] || entry.de;
  return String(s).replace(/_/g, " ");
}

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const q = new URLSearchParams(window.location.search).get("lang");
    if (q === "de" || q === "en") return q;
    return localStorage.getItem("jd_lang") || "de";
  });
  useEffect(() => {
    localStorage.setItem("jd_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = (key) => DICT[lang][key] || DICT.de[key] || key;
  const sl = (s) => statusLabel(s, lang);
  const pickL = (obj, field) => {
    if (!obj) return "";
    return obj[`${field}_${lang}`] ?? obj[`${field}_de`] ?? obj[field] ?? "";
  };
  return (
    <I18nContext.Provider value={{ lang, setLang, t, sl, pickL }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
